module.exports = __webpack_public_path__ + "static/media/open-engine-graph2.40fd8d87.png";